// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

//get all
export const getProforma = createAsyncThunk('proformaSlice/getProforma', async (data) => {
    const query = queryString.stringify(data);

    try {
        let response = await axios.get('/Proforma?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getProformaFilter = createAsyncThunk('proformaSlice/getProformaFilter', async (data) => {
    const query = queryString.stringify(data);

    try {
        let response = await axios.get('/Proforma?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
//get by id
export const getProformabyid = createAsyncThunk('proformaSlice/getProformabyid', async (id) => {
    try {
        let response = await axios.get('/Proforma/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getDayAdjustmentStatus = createAsyncThunk('proformaSlice/getDayAdjustmentStatus', async () => {
    try {
        let response = await axios.get('/DayAdjustment?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
//delete
export const deleteProforma = createAsyncThunk('proformaSlice/deleteProforma', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Proforma/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Proforma deleted successfully.');
        await dispatch(getProforma());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
//get proformano
export const getProformaNo = createAsyncThunk('proformaSlice/getProformaNo', async () => {
    try {
        let response = await axios.get('/Proforma/proforma-number', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
// create proforma
export const createProforma = createAsyncThunk('proformaSlice/createProforma', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Proforma', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Proforma added succesfully.');
        await dispatch(getProforma());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

//update
export const updateProforma = createAsyncThunk('proformaSlice/updateProforma', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Proforma/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Proforma updated succesfully.');
        await dispatch(getProforma());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
//ack
export const updateAcknowledgeStatus = createAsyncThunk('proformaSlice/updateAcknowledgeStatus', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Proforma/update-ack-status/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Acknowledge Status Update succesfully.');
        await dispatch(getProforma());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateFinalProforma = createAsyncThunk('proformaSlice/updateFinalProforma', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Proforma/upload-final-proforma/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Final Invoice updated succesfully.');
        await dispatch(getProforma());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateDayAdjustmentStatus = createAsyncThunk('proformaSlice/updateDayAdjustmentStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/DayAdjustment/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getDayAdjustment());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const proformaSlice = createSlice({
    name: 'proformaSlice',
    initialState: {
        proforma: [],
        proformafilter: []
    },
    extraReducers: (builder) => {
        builder.addCase(getProforma.fulfilled, (state, action) => {
            state.proforma = action?.payload;
            return;
        });
        builder.addCase(getProformaFilter.fulfilled, (state, action) => {
            state.proformafilter = action?.payload;
            return;
        });
    }
});

export default proformaSlice.reducer;
